import React from 'react'
import withLayout from '../../../layout/withLayout'
import { lifecycle } from 'recompose'
import FunnelStartSelector from './FunnelStartSelector'
import FunnelStepList from './FunnelStepList'
import CurrentState from './CurrentState'


const FunnelBuilder = (props) => {
    return (
        <div>
            <FunnelStartSelector {...props}/>
            <FunnelStepList {...props}/>
            <CurrentState {...props}/>
        </div>)
}


export default lifecycle({
    componentDidMount () {
        this.props.findCohort()
    },
})(withLayout(FunnelBuilder))





// WEBPACK FOOTER //
// ./src/modules/analytics/component/funnel-builder/FunnelBuilder.js